<!-- 选项列表 -->
<template>
  <div
    :class="{
      'custom-option': !isMobile,
      'mobile-custom-option': isMobile,
      'is-corrected': isCorrected,
    }"
  >
    <div
      v-for="(option, index) in options"
      :key="option.value"
      class="option-item"
      @click="handleOptionClick(option.value)"
    >
      <label class="custom-radio">
        <!-- 点击custom-radio会触发两次handleOptionClick：解决disabled设为true -->
        <input
          :type="type"
          :value="option.value"
          :checked="judgeChecked(option.value)"
          :disabled="true"
        />
        <span
          class="radio-circle"
          :class="{
            'is-disabled': disabled,
            'is-right': option.right === 1,
            'is-wrong': option.right === 2,
          }"
          >{{ getLetter(index) }}</span
        >
      </label>
      <div class="option-wrap">
        <div class="option-label" v-html="option.label"></div>
        <template v-if="isMobile && isCorrected">
          <img
            class="right-icon"
            v-if="option.right === 1"
            src="../../../assets/images/homework/right-icon.png"
            alt=""
          />
          <img
            class="wrong-icon"
            v-else-if="option.right === 2 && judgeChecked(option.value)"
            src="../../../assets/images/homework/wrong-icon.png"
            alt=""
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    type: {
      type: String,
      default: "radio",
    },
    // 选项数组，包含值和显示标签
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 初始选中的值
      //   selectedValue: null,
    };
  },
  methods: {
    // 根据索引获取对应的字母（A、B、C、D）
    getLetter(index) {
      return String.fromCharCode(65 + index);
    },
    // 处理整个选项的点击事件
    handleOptionClick(value) {
      if (this.disabled) {
        return;
      }
      value = String(value);
      if (this.type === "checkbox") {
        let arr = [];
        if (this.value) {
          arr = this.value.split(",");
        }
        if (arr.includes(value)) {
          arr = arr.filter((item) => item !== value);
        } else {
          arr.push(value);
        }
        if (arr.length) {
          arr = arr.join(",");
        } else {
          arr = "";
        }
        this.$emit("input", arr);
        this.$emit("select-change", arr);
      } else {
        this.$emit("input", value);
        this.$emit("select-change", value);
      }
    },
  },
  computed: {
    ...mapState("defaultHomework", ["isCorrected", "isMobile"]),
    judgeChecked() {
      return (value) => {
        if (this.type === "checkbox") {
          return this.value.split(",").includes(value);
        } else {
          return this.value === value;
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-option {
  .option-item {
    display: flex;
    padding: 10px 8px;
    border-radius: 8px;
    cursor: pointer;
    &:hover {
      background: var(--input-bg, #f7f8fa);
    }
  }
  .custom-radio {
    position: relative;
    cursor: pointer;
    user-select: none;
    margin-right: 8px;
  }

  .custom-radio input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .radio-circle {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border: 1px solid var(--border-subtle, #e5e6eb);
    background: var(--card-bg, #fff);
    border-radius: 50%;
    font-weight: 500;
    font-size: 15px;
    color: var(--text-secondary, #4e5969);
    line-height: 1;
    padding-bottom: 1px;
    &.is-right::after {
      display: flex;
      content: "";
      position: absolute;
      width: 16px;
      height: 16px;
      background: url("../../../assets/images/homework/right-icon.png")
        no-repeat;
      background-size: 100% 100%;
      top: -3px;
      right: -7px;
    }
  }

  // 选中状态样式
  .custom-radio input:checked ~ .radio-circle {
    border-color: #386bff;
    background-color: #386bff;
    color: #ffffff;
    position: relative;
    &.is-disabled {
      background: #bedaff;
      border-color: #bedaff;
      color: var(--text-secondary, #4e5969);
    }
    &.is-wrong::after {
      display: flex;
      content: "";
      position: absolute;
      width: 16px;
      height: 16px;
      background: url("../../../assets/images/homework/wrong-icon.png")
        no-repeat;
      background-size: 100% 100%;
      top: -3px;
      right: -7px;
    }
  }
  .option-label {
    font-weight: 400;
    font-size: 16px;
    color: var(--text-primary, #1d2129);
    line-height: 26px;
    padding-top: 1px;
    line-break: anywhere;
  }
}

.mobile-custom-option {
  .option-item {
    display: flex;
    padding: 0.29rem 0.32rem 0.29rem 0.13rem;
    background: var(--input-bg, #f7f8fa);
    border-radius: 0.21rem;
    margin-bottom: 0.32rem;
  }
  .custom-radio {
    position: relative;
    user-select: none;
    margin-right: 0.45rem;
  }

  .custom-radio input {
    position: absolute;
    opacity: 0;
  }

  .radio-circle {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
    font-weight: 500;
    font-size: 0.4rem;
    color: var(--text-secondary, #4e5969);
    line-height: 1;
    position: relative;
    padding-bottom: 1px;
    &::after {
      display: flex;
      content: "";
      position: absolute;
      width: 0.03rem;
      height: 0.32rem;
      background: var(--border-subtle, #e5e6eb);
      top: 50%;
      transform: translateY(-50%);
      right: -0.11rem;
    }
  }

  // 选中状态样式
  .custom-radio input:checked ~ .radio-circle {
    background-color: #386bff;
    color: #ffffff;
    position: relative;
  }
  &.is-corrected {
    .custom-radio input:checked ~ .radio-circle {
      background: #94bfff;
      color: var(--text-secondary, #4e5969);
    }
  }
  .option-label {
    font-weight: 400;
    font-size: 0.43rem;
    color: var(--text-primary, #1d2129);
    line-height: 0.59rem;
    padding-top: 0.08rem;
    padding-bottom: 0.08rem;
    line-break: anywhere;
  }

  .right-icon,
  .wrong-icon {
    width: 0.53rem;
    height: 0.53rem;
    margin-top: 0.08rem;
    margin-left: 0.1rem;
  }
  .option-wrap {
    flex: 1;
    display: flex;
    justify-content: space-between;
  }
}
</style>
